import ActionTypes from '@ziynx/action-types';

type AdminActions = {
  type: string,
  id: string,
}

const initialState = {
  newOriginal: {
    fetching: false,
    posting: false,
  },
};

export default function reduceOriginal(state = initialState, action: AdminActions) {
  switch (action.type) {
  case ActionTypes.originals.post.START:
    return {
      ...state,
      newOriginal: {
        posting: true,
      },
    };
  case ActionTypes.originals.post.SUCCESS:
    return {
      ...state,
      newOriginal: {
        posting: false,
      },
    };
  case ActionTypes.originals.post.ERROR:
    return {
      ...state,
      newOriginal: {
        posting: false,
      },
    };
  case ActionTypes.originals.get.START:
    return {
      ...state,
      [action.id]: {
        ...(state[action?.id] || {}),
        fetching: true,
      },
    };

  case ActionTypes.originals.get.SUCCESS:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        fetching: false,
      },
    };

  case ActionTypes.originals.get.ERROR:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        fetching: false,
      },
    };

  case ActionTypes.originals.patch.START:
    return {
      ...state,
      [action.id]: {
        ...(state[action?.id] || {}),
        isPatching: true,
      },
    };

  case ActionTypes.originals.patch.SUCCESS:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        isPatching: false,
      },
    };

  case ActionTypes.originals.patch.ERROR:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        isPatching: false,
      },
    };

  case ActionTypes.originals.clearImageUploads:
    if (action?.id) {
      const { image, ...rest } = state[action.id];
      return {
        ...state,
        [action.id]: {
          ...rest,
        },
      };
    }
    return initialState;

  case ActionTypes.originals.clearVideoUploads:
    if (action?.id) {
      const { video, ...rest } = state[action.id];
      return {
        ...state,
        [action.id]: {
          ...rest,
        },
      };
    }
    return initialState;

  default:
    return state;
  }
}
